import axios from 'axios';
import Swal from "sweetalert2";
import {baseUrl,errorTranslate} from './util';


export const createHighlightList = ({key,value}) => {
    const urlParams = new URLSearchParams(window.location.search);
    const year = urlParams.get("year");
    var data = {
        "key": key,
        "value": value,
        "year": year,
    };
        
    var config = {
        method: 'post',
        url: baseUrl + '/api/business/report/highlight',
        headers: { 
        'Authorization': 'Bearer ' + localStorage.getItem("access_token"), 
        'Content-Type': 'application/json'
        },
        data : data
    };
    
    axios(config)
    .then(function (response) {

    })
    .catch(function (error) {
        // console.log(error)
        if (error.response.data.message == "key exist") {
            updateHighlightList({key:key,value:value})
        }
    });
}

export const updateHighlightList = ({key,value,swal=false}) => {
    const urlParams = new URLSearchParams(window.location.search);
    const year = urlParams.get("year");
    var data = {
        "key": key,
        "value": value == "" ? "[]":JSON.stringify(value),
        "year": year
    };
        
    var config = {
        method: 'put',
        url: baseUrl + '/api/business/report/highlight/'+key,
        headers: { 
        'Authorization': 'Bearer ' + localStorage.getItem("access_token"), 
        'Content-Type': 'application/json'
        },
        data : data
    };
    
    axios(config)
    .then(function (response) {
        if (swal){
            Swal.fire({
                title: 'Success!',
                icon: 'success',
                // text: error,
                confirmButtonColor: '#a9c1b4',
                // width: 600,
                // padding: '3em',
                color: '#476355',
                background: '#f1f8ef',
            })
        }
    })
    .catch(function (error) {
        if (swal){
            Swal.fire({
                title: errorTranslate(),
                icon: 'error',
                text: error,
                confirmButtonColor: '#a9c1b4',
                // width: 600,
                // padding: '3em',
                color: '#476355',
                background: '#f1f8ef',
            })
        }
        // setSaving(false)
    });
}

export const getHighlightList = ({key,setValue}) => {
    const urlParams = new URLSearchParams(window.location.search);
    const year = urlParams.get("year");
    var config = {
        method: 'get',
        url: baseUrl + '/api/business/report/highlight/'+key, 
        headers: { 
            'Authorization': 'Bearer ' + localStorage.getItem("access_token"), 
            'Content-Type': 'application/json'
        },
        params:{
            year:year
        }
    };
        
    axios(config)
        .then(function (response) {
            if(response.data.data.value == "emptyvalue")
                setValue("")
            else{
                setValue(JSON.parse(response.data.data.value))
            }
        })
        .catch(function (error) {
            if (error.response.status == 404) {
                createHighlightList({key:key,value:"[]"})
            }
        });
    }